const planFactory = (
  checkout = '',
  name,
  originalPrice,
  promotionalPrice,
  features = [],
  featuresNotIncluded = [],
  popular = false
) => ({
  popular,
  name,
  originalPrice,
  promotionalPrice,
  features,
  featuresNotIncluded,
  checkout
})

export default [
  planFactory('http://mon.net.br/f41q0', 'Iniciante', '249,00', '174,30',
    [
      '8 publicações geradas pelos robôs',
      '8 rejeições de publicações',
      'Publicações autorais ilimitadas',
      '15 citações (não geradas pelos robôs)',
      'Banco de Imagens HD',
      'Editor de imagem',
      'Hashtags por inteligência artificial',
      'Estatísticas das redes sociais',
      'Agendamento de publicações ilimitados'
    ],
    [
      'Suporte prioritário',
      'Gerente de conta dedicado'
    ]
  ),
  planFactory('http://mon.net.br/f41ux', 'Autoridade', '428,00', '299,60',
    [
      '16 publicações geradas pelos robôs',
      '16 rejeições de publicações',
      'Publicações autorais ilimitadas',
      '15 citações (não geradas pelos robôs)',
      'Banco de Imagens HD',
      'Editor de imagem',
      'Hashtags por inteligência artificial',
      'Estatísticas das redes sociais',
      'Agendamento de publicações ilimitados',
      'Suporte prioritário'
    ],
    [
      'Gerente de conta dedicado'
    ],
    true
  ),
  planFactory('http://mon.net.br/f41yr', 'Rock Star', '740,00', '518,50',
    [
      '31 publicações geradas pelos robôs',
      '31 rejeições de publicações',
      'Publicações autorais ilimitadas',
      '15 citações (não geradas pelos robôs)',
      'Banco de Imagens HD',
      'Editor de imagem',
      'Hashtags por inteligência artificial',
      'Estatísticas das redes sociais',
      'Agendamento de publicações ilimitados',
      'Suporte prioritário',
      'Gerente de conta dedicado'
    ]
  )
]
